module.exports = __webpack_public_path__ + "img/4_no.10730049.svg";